import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ticketApi = createApi({
  reducerPath: "ticketApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "communication/ticket",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllTickets: builder.query({
      query: ({ sort } = {}) => {
        let url;

        if (sort) {
          url = `?sort=${sort}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getTicketById: builder.query({
      query: ({ id }) => {
        return {
          url: `/${id}`,
          method: "GET",
        };
      },
    }),

    createTicket: builder.mutation({
      query: ({ ...body }) => {
        const payload = { ...body };

        return {
          url: "/",
          method: "POST",
          body: payload,
        };
      },
    }),

    closeTicket: builder.mutation({
      query: ({
        ticketId
      } = {}) => {

        return {
          url: `/${ticketId}/close-by-user`,
          method: "PATCH",
          // body: payload,
        };
      },
    }),
  }),
});

export const {
  useGetAllTicketsQuery,
  useCreateTicketMutation,
  useGetTicketByIdQuery,
  useCloseTicketMutation
} = ticketApi;
